import { formatNumber } from '@angular/common';
import { DestroyRef, inject, LOCALE_ID, Service, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Promos } from '../../data/models';
import { mapPromos, NO_PROMOS } from '../../data/qr.mapper';
import { QrService } from '../../data/qr.service';
import { LanguageService } from '../../core/language.service';
import { QrTokenService } from '../../core/qr-token.service';

/** Акции заведения: вторая волна после меню; ошибка — просто меню без скидок. */
@Service({ autoProvided: false })
export class PromoStore {
  private qr = inject(QrService);
  private qrToken = inject(QrTokenService);
  private language = inject(LanguageService);
  private locale = inject(LOCALE_ID);
  private destroyRef = inject(DestroyRef);

  private readonly _promos = signal<Promos>(NO_PROMOS);
  readonly promos = this._promos.asReadonly();

  load(): void {
    this.qr
      .getPromos(this.qrToken.tableUuid())
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (res) => this._promos.set(mapPromos(res)),
        error: () => {},
      });
  }

  badge(percent: number, upTo = false): string {
    const n = formatNumber(percent, this.locale, '1.0-2');
    return this.language.t(upTo ? 'menu.promoBadgeUpTo' : 'menu.promoBadge', { n });
  }
}
